import { useQuery } from "@apollo/client";

import { Stack } from "types/generated";

import { GET_STACK_SETTINGS } from "./gql";

const useGetStackSettings = (stackId: string | undefined) => {
  const { data, error, loading } = useQuery<{ stack: Stack }>(GET_STACK_SETTINGS, {
    variables: {
      stackId,
    },
    skip: !stackId,
  });

  return {
    stackSettings: data?.stack,
    error,
    loading,
  };
};

export default useGetStackSettings;
